import React, { useRef, useState, useEffect } from "react";

const YAxis = ({ ticks, onWidthChange, formatTick }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new ResizeObserver(() => {
      if (ref.current) {
        onWidthChange(ref.current.offsetWidth);
      }
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [onWidthChange]);

  return (
    <div
      ref={ref}
      className="flex flex-col-reverse justify-between items-end h-full pr-2"
    >
      {ticks.map((t, i) => (
        <span key={i} className="text-xs text-gray-600 whitespace-nowrap">
          {formatTick ? formatTick(t) : t}
        </span>
      ))}
    </div>
  );
};

export default YAxis;
